// @flow
import React from 'react';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
const cx = classNames.bind(styles);

const RichText = ({ className, content, hasDarkBackground }) => {
  return (
    <div
      className={cx(className, styles.root, {
        [styles.hasDarkBackground]: hasDarkBackground,
      })}
      dangerouslySetInnerHTML={{ __html: content }}
      data-has-dark-background={hasDarkBackground}
    />
  );
};

RichText.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired,
  hasDarkBackground: PropTypes.bool,
};

export default RichText;
